// extracted by mini-css-extract-plugin
module.exports = {"tech-icon":"tech-icon_tech-icon__1feVO","tooltip-text":"tech-icon_tooltip-text__L8h_g"};